import { createElementBlock as t, openBlock as r, createElementVNode as l } from "vue";
const c = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-share-twitter"
};
function n(o, e) {
  return r(), t("svg", c, e[0] || (e[0] = [
    l("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: "#F2F2F2",
      class: "svg__fill--secondary-grey-01"
    }, null, -1),
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.7778 11.0263c-.5716.2603-1.1869.4363-1.8325.515.6592-.4045 1.1651-1.0459 1.4034-1.8099-.6172.3745-1.2993.647-2.0279.793-.5807-.63571-1.4107-1.0327-2.3292-1.0327-1.7612 0-3.1902 1.4653-3.1902 3.2724 0 .2565.0274.5056.0822.7453-2.6524-.1367-5.0035-1.4382-6.57847-3.4203-.27483.485-.43187 1.0477-.43187 1.6469 0 1.1348.56335 2.1367 1.41974 2.7237-.52221-.0159-1.01526-.1648-1.44622-.4082v.0403c0 1.5861 1.10022 2.9091 2.56112 3.2087-.2676.0768-.5497.1151-.8409.1151-.2055 0-.4063-.0196-.60083-.058.40633 1.2996 1.58413 2.2462 2.98113 2.2715-1.092.8782-2.4689 1.4016-3.96356 1.4016-.25748 0-.51222-.015-.76148-.0449 1.41248.9269 3.09064 1.469 4.89214 1.469 5.8708 0 9.0802-4.9858 9.0802-9.3106 0-.1423-.0028-.2846-.0082-.4241.6236-.4616 1.165-1.0374 1.5914-1.6938Z",
      fill: "#0F0F0F",
      class: "svg__fill--black"
    }, null, -1)
  ]));
}
const s = { render: n };
export {
  s as default,
  n as render
};
